import i18n from "i18n";
import TrafficLimitViolationConfig from "./TrafficLimitViolationConfig";
export default {
  systemConfigurations: [
    {
      component: TrafficLimitViolationConfig,
      configType: "org.graylog.plugins.license.violations.TrafficLimitViolationSettings",
      get displayName() {
        return i18n.t("traffic_violation.title", { ns: "enterprise_license" });
      },
      permissions: "clusterconfigentry:read"
    }
  ]
};
